import {z} from 'zod'

import {apiFetch} from '../api/fetch'
import {
    type CreateServiceTypeInput,
    createServiceTypeRequestSchema,
    type CreateTransportationRatePolicyInput,
    createTransportationRatePolicyRequestSchema,
    type ServiceType,
    serviceTypeSchema,
    type TransportationRatePolicy,
    transportationRatePolicySchema,
    type UpdateServiceTypeInput,
    updateServiceTypeRequestSchema,
} from './schemas'

export async function getTransportationRatePolicy(): Promise<TransportationRatePolicy | null> {
    const raw = await apiFetch<unknown>('/settings/transportation-rate-policy')
    if (raw == null) {
        return null
    }
    return transportationRatePolicySchema.parse(raw)
}

export async function createTransportationRatePolicy(
    input: CreateTransportationRatePolicyInput,
): Promise<TransportationRatePolicy> {
    const body = createTransportationRatePolicyRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/settings/transportation-rate-policy', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return transportationRatePolicySchema.parse(raw)
}

export async function listPaymentTerms(): Promise<string[]> {
    const raw = await apiFetch<unknown>('/settings/payment-terms')
    return z.array(z.string()).parse(raw)
}

export async function listActiveServiceTypes(): Promise<ServiceType[]> {
    const raw = await apiFetch<unknown>('/settings/service-types')
    return z.array(serviceTypeSchema).parse(raw)
}

export async function listAllServiceTypes(): Promise<ServiceType[]> {
    const raw = await apiFetch<unknown>('/settings/service-types/all')
    return z.array(serviceTypeSchema).parse(raw)
}

export async function createServiceType(input: CreateServiceTypeInput): Promise<ServiceType> {
    const body = createServiceTypeRequestSchema.parse(input)
    const raw = await apiFetch<unknown>('/settings/service-types', {
        method: 'POST',
        body: JSON.stringify(body),
    })
    return serviceTypeSchema.parse(raw)
}

export async function updateServiceType(
    id: string,
    input: UpdateServiceTypeInput,
): Promise<ServiceType> {
    const body = updateServiceTypeRequestSchema.parse(input)
    const raw = await apiFetch<unknown>(`/settings/service-types/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
    })
    return serviceTypeSchema.parse(raw)
}
